<template>
  <Container
    v-if="prospects.length"
    class="mb-4 mt-12 lg:mb-24 lg:mt-16">
    <h2 class="mb-6 max-w-3xl text-3xl leading-[1.2] tracking-[-1px] text-white lg:text-5xl">
      {{ title }}
    </h2>

    <div class="pb-20 pt-6 lg:pb-24">
      <NuxtLink
        v-for="prospect in prospects"
        :key="prospect.id"
        :href="prospect.uri"
        class="group flex flex-col items-start justify-between border-b border-gray-400 pb-6 pt-6 transition lg:flex-row lg:items-center lg:px-4 lg:pt-8 lg:hover:bg-gray-500">
        <div>
          <div class="text-xl text-gray-100 transition lg:text-2xl lg:text-gray-200 lg:group-hover:text-white">
            {{ prospect.title }}
          </div>
          <div>
            <span
              v-for="(location, index) in prospect.locations"
              :key="location.key"
              class="mt-1 text-gray-250"
              >{{ index > 0 ? ' • ' : '' }}{{ location.label }}</span
            >
          </div>
        </div>
      </NuxtLink>
    </div>
  </Container>
</template>

<script setup lang="ts">
  import type { Prospect } from '~/models/jobs'

  defineProps<{
    title: string
  }>()

  const { data: prospects } = await useAsyncData('prospects', () =>
    queryContent<Prospect>('prospects').sort({ title: 1 }).find()
  )
</script>
